// src/pages/ParentingSupport.tsx
import React from 'react';
import CategoryPage from './CategoryPage';

const ParentingSupport: React.FC = () => <CategoryPage categoryId="parenting" art="family" />;

export default ParentingSupport;
